import Recharge from '../../pages/mine/Recharge.vue'
import Withdraw from '../../pages/mine/Withdraw'
import Personalreport from '../../pages/mine/Personalreport'
import WithdrawRecord from '../../pages/mine/WithdrawRecord'
import GameRecord from '../../pages/mine/GameRecord'
import RechargeRecord from '../../pages/mine/RechargeRecord'
import Moneylog from '../../pages/mine/Moneylog'
import Channel from '../../pages/mine/Channel'

// wallet 页面路由：统一公开路径及路由名称，组件和 meta 保持不变。
const routes = [
  { path: '/wallet/deposit', name: 'wallet-deposit', component: Recharge, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/wallet/withdraw', name: 'wallet-withdraw', component: Withdraw, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/wallet/reports', name: 'wallet-reports', component: Personalreport, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/wallet/withdrawals', name: 'wallet-withdrawals', component: WithdrawRecord, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/wallet/game-records', name: 'wallet-game-records', component: GameRecord, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/wallet/deposits', name: 'wallet-deposits', component: RechargeRecord, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/wallet/transactions', name: 'wallet-transactions', component: Moneylog, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/wallet/deposit/channel', name: 'wallet-deposit-channel', component: Channel, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
]

export default routes
